import type { CrmChatProviderKey } from '@/api/types/crm/crmLeadFunnels.types'

export const CRM_CHAT_PROVIDER_KEYS: readonly CrmChatProviderKey[] = [
  'vkontakte',
  'telegram',
  'max',
  'wazzup',
]

export const CRM_INTEGRATION_TEXT_CHAT_PROVIDERS = [
  'vkontakte',
  'max',
  'telegram',
  'wazzup',
] as const satisfies readonly CrmChatProviderKey[]

export type CrmIntegrationTextChatProvider =
  (typeof CRM_INTEGRATION_TEXT_CHAT_PROVIDERS)[number]

export const isCrmIntegrationTextChatProvider = (
  provider: CrmChatProviderKey,
): provider is CrmIntegrationTextChatProvider =>
  (CRM_INTEGRATION_TEXT_CHAT_PROVIDERS as readonly string[]).includes(provider)

/**
 * Авто-mark-read при открытии чата / входящих.
 * Раньше: TG/MAX/Wazzup = true, VK = false.
 * Сейчас везде только кнопка «Прочитать все» (как VK).
 */
export const isCrmIntegrationAutoMarkReadProvider = (
  _provider: CrmChatProviderKey,
): boolean => false

/** Исходящие вложения: TG / MAX / VK / Wazzup. */
export const isCrmIntegrationOutgoingAttachmentsEnabled = (
  provider: CrmChatProviderKey,
): boolean =>
  provider === 'max' ||
  provider === 'telegram' ||
  provider === 'vkontakte' ||
  provider === 'wazzup'

/** Wazzup: text и attachment нельзя в одном send — шлём двумя сообщениями. */
export const isCrmIntegrationOutgoingTextAttachmentXor = (
  provider: CrmChatProviderKey,
): boolean => provider === 'wazzup'

export const parseCrmChatProviderKey = (
  value: string | null | undefined,
): CrmChatProviderKey | null => {
  if (value == null) {
    return null
  }
  if (value === 'vk') {
    return 'vkontakte'
  }
  if (value === 'tg') {
    return 'telegram'
  }
  return CRM_CHAT_PROVIDER_KEYS.includes(value as CrmChatProviderKey)
    ? (value as CrmChatProviderKey)
    : null
}

export const resolveCrmChatProviderKey = (
  value: CrmChatProviderKey | string | null | undefined,
  fallback: CrmChatProviderKey = 'vkontakte',
): CrmChatProviderKey => parseCrmChatProviderKey(value) ?? fallback
